import { useEffect } from 'react'
import { showToast } from 'shared/ui/Toast/lib/showToast'
import { logger } from 'shared/lib'
import { type IResponseEventRegisterOrganizationError } from 'entities/Auth/api/types'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type RegisterStore } from 'pages/register/ui/Register'

export const useEventRegisterOrganizationError = (store: RegisterStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseEventRegisterOrganizationError) => {
    if (store) {
      showToast({
        type: 'error',
        title: data.error_message,
      })
      store.setLoading(false)
    }
    logger.error(data)
  }

  useEffect(() => {
    if (!store.profileChanelSubscribed) return

    const listener = websocket.on(WebsocketEvent.RegisterOrganizationError, handler)

    return () => {
      listener()
    }
  }, [store.profileChanelSubscribed])
}
